module.exports = __webpack_public_path__ + "img/osago-advantages.e537ec2.png";